import React from 'react';

interface SummaryGridFieldProps {
  label: string;
  value: React.ReactNode;
  emptyLabel?: string;
}

const SummaryGridField: React.FC<SummaryGridFieldProps> = ({
  label,
  value,
  emptyLabel = 'Não informado',
}) => {
  const display =
    value !== undefined && value !== null && String(value).trim() !== '' ? value : emptyLabel;
  return (
    <div className="mb-3">
      <div className="text-muted summary-field-label">{label}</div>
      <div className="font-weight-medium text-dark summary-field-value">{display}</div>
    </div>
  );
};

export default SummaryGridField;
